export default function strapiImageLoader({ src, width, quality }) {
  // If the src is already a full external URL, return as is
  if (src.startsWith('http://') || src.startsWith('https://')) {
    return src;
  }

  // If the src is a Strapi local URL, return as is
  if (src.startsWith('http://localhost:1337') ||
      src.startsWith('http://localhost:1339') ||
      src.startsWith('http://strapi:1337') ||
      src.startsWith('http://host.docker.internal')) {
    return src;
  }

  // For relative paths, prepend the Strapi URL
  const strapiUrl = process.env.NEXT_PUBLIC_STRAPI_URL || 'http://localhost:1337';
  return `${strapiUrl}${src}`;
}
